"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useArbitraryOptionAddition = require("./useArbitraryOptionAddition");
Object.keys(_useArbitraryOptionAddition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useArbitraryOptionAddition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useArbitraryOptionAddition[key];
    }
  });
});